// Select bileşenlerinde "kişi seçeneği" tanıma ve ortak avatar render'ı.
//
// Kural (ürün sahibi): kullanıcı listelenen HER yerde — tablo hücresi, dropdown
// seçeneği, seçili değer, çoklu-seçim rozeti — profil fotoğrafı varsa gösterilir,
// yoksa ad-soyad baş harfleri. Bunu her çağrı yerinin `renderOption` yazmasına
// bırakmak, uygulama genelinde tutarsızlığın kaynağıydı (bazı select'lerde avatar
// vardı, çoğunda yoktu). Bu yüzden tanıma seçeneğin KENDİSİNDEN yapılır:
// seçenek nesnesi bir kişi alanı taşıyorsa select otomatik avatarlı render eder.
//
// Bunun ön koşulu: kişi arayan her `onSearch`/`options` üreticisi seçeneğe
// `profilePicture` anahtarını KOYMALI (değeri null olsa bile). Anahtar yoksa
// seçenek "kişi değil" sayılır ve düz metin olarak çizilir.

const PICTURE_KEYS = ['profilePicture', 'userProfilePicture', 'employeeProfilePicture', 'avatar'];
// Tek ad kaynağı: `firstName`/`lastName`. (API bir zamanlar `legalFirstName`
// döndürüyordu; o alan kişi verisinin ikinci kopyasıydı ve kaldırıldı.)
const NAME_PART_KEYS = [
    ['firstName', 'lastName'],
];

export const personPicture = (opt) => {
    if (!opt || typeof opt !== 'object') return null;
    for (const key of PICTURE_KEYS) {
        if (opt[key]) return opt[key];
    }
    return null;
};

export const isPersonOption = (opt) => {
    if (!opt || typeof opt !== 'object') return false;
    if (PICTURE_KEYS.some((key) => key in opt)) return true;
    return NAME_PART_KEYS.some(([a, b]) => a in opt && b in opt);
};

// AsyncGenericSelect'in kendi formatLabel'ıyla AYNI öncelik sırası —
// seçili değer ile listedeki seçenek asla farklı metin göstermemeli.
export const personOptionLabel = (opt) => {
    if (!opt) return '';
    if (typeof opt !== 'object') return String(opt);
    if (opt.label) return opt.label;
    if (opt.firstName || opt.lastName)
        return `${opt.firstName || ''} ${opt.lastName || ''}`.trim();
    return opt.name || opt.fullName || opt.title || '';
};
